import { ErrorFilled } from '@carbon/react/icons';
import { TextInput, Layer } from '@carbon/react';
import { ReactNode } from 'react';
import classNames from 'classnames';
import style from './text-field.module.scss';

export interface TextFieldProps {
  id: string;
  labelText: ReactNode;
  value: string | null | undefined;
  onChange: (value: string) => void;
  onBlur?: () => void;
  autoComplete?: string;
  placeholder?: string;
  disabled?: boolean;
  light?: boolean;
  invalid?: boolean;
  invalidText?: string;
  required?: boolean;
}

export const TextField = ({
  id,
  labelText,
  value,
  onChange,
  onBlur,
  autoComplete,
  placeholder,
  disabled,
  light = false,
  invalid,
  invalidText,
  required,
}: TextFieldProps) => {
  const textInput = (
    <TextInput
      id={id}
      labelText={
        <label>
          {labelText}
          {required && <span className={style.required}> (Required)</span>}
          {invalid && (
            <span className={style.required}>
              <ErrorFilled />
            </span>
          )}
        </label>
      }
      size="md"
      value={value || ''}
      onChange={({ target: { value } }) => onChange(value)}
      onBlur={onBlur}
      invalid={invalid}
      invalidText={invalid ? invalidText : ''}
      autoComplete={autoComplete}
      placeholder={placeholder}
      disabled={disabled}
    />
  );

  return (
    <div className={classNames({ [style.light]: light })}>
      {!light ? <Layer>{textInput}</Layer> : textInput}
    </div>
  );
};
